<script lang="ts">
	import { ErrorService } from "../services/error.service";
	export let klass = ''
	export let items = []
	export let rows = []
	export let selectRow: any = (event) => {
		ErrorService.unimplemented()
	}
	export let asLink = false
</script>

<div class="{klass}">
</div>

<tbody>
	{#each rows as row, i}
		<tr
			class="border-b cursor-pointer transition-color duration-100 hover:bg-gray-100"
			on:click={selectRow(row.id, asLink)}
		>
			{#each items as item, i}
				{#if item.placeholderType === 'image'}
					<td class="placeholder--image" style={item.style.join(' ')}>
						<img src="{row.image === '' ? '/img/no_image.png' : row.image}" alt="noimage">
					</td>
				{:else}
					<td class="whitespace-pre-wrap px-2" style={item.style.join(' ')}>
						{row[item.key]}
					</td>
				{/if}
			{/each}
		</tr>
	{/each}
</tbody>

<style lang="postcss">
	.placeholder--image {
		width: 200px;
		height: 100px;
	}
</style>
